export default "__VITE_ASSET__f2edc041__"